export default {
  scam: 'Golpe',
  account_takeover: 'Acesso não autorizado',
  coercion: 'Coação/Extorsão',
  fraudulent_access: 'Roubo de credenciais',
  unknown: 'Outros'
};
